import React from'react';export var SettingsContext=React.createContext();